<div class="px-1 py-2 surface-ground md:px-1 lg:px-2">
  <block-ui>
    <div *ngIf="this.iAmLoading">
      <h2>Getting your information ....</h2>
    </div>
    <div *ngIf="!this.iAmLoading">
      <section class="px-6 py-1 surface-section">
        <header
          class="flex w-full p-4 pb-5 m-4 text-primary-800 justify-content-between align-items-center border-bottom-1 surface-border">
          <div>
            <h2 class="mt-0 mb-3 text-2xl font-medium text-900">
              Payment Methods
            </h2>
            <p class="mt-0 mb-0 text-base font-normal text-500">
              Choose from a variety of convenient payment options
            </p>
          </div>
        </header>
        <div class="content">
          <!-- Empty State Box -->
          <div class="empty-state">
            <div class="icon">
              <img src="/dashboard/payment/wallet.png" alt="Payment Icon" />
            </div>
            <h2>No Payment Method Found</h2>
            <p>Add a payment method to view it here</p>
          </div>

          <!-- Add Payment Method Button -->
          <div class="flex items-center justify-end w-full add-payment-method">
            <p-button
            label="Add a Payment Method"
            pRipple
            icon="pi pi-wallet"
            class="p-4 m-2 rounded-md bg-primary"
            (onClick)="addPaymentMethod()" />
          </div>
        </div>
      </section>
    </div>
  </block-ui>
</div>
